import React from 'react';
import PropTypes from 'prop-types';
import styled from 'styled-components';

const Logo = styled.div`
  background-image: url(${props => props.url});
  background-size: contain;
  background-position: center;
  background-repeat: no-repeat;
  height: 100%;
  width: 100%;
`;

const OrgLogo = ({ value }) => <Logo url={value} />;

OrgLogo.propTypes = { value: PropTypes.string };
OrgLogo.defaultProps = { value: '' };

export default OrgLogo;
